import React,{useEffect, useState, useCallback} from 'react';
import Grid from "@material-ui/core/Grid";
import TextField from '@material-ui/core/TextField';
import {Trans} from "@lingui/macro";
import {Card, CardContent, Typography, Button, Box, Divider} from '@material-ui/core';
import {default as MaterialTable} from "../../components/MaterialTable/MaterialTable";
import StatsService from '../../http-services/stats.service';
import BackdropLoader from "../../components/BackdropLoader/Backdrop";
import { formatSeconds } from '../../utils/common';
import { makeStyles } from '@material-ui/core/styles';
import {Form, Field} from 'react-final-form';
import Modal from '../../components/Modal/Modal';
import moment from 'moment';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { upperFirst } from '../../utils/string';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    btn:{
        margin: '15px 0',
        backgroundColor: '#cfdde4',
        "&:hover":{
            backgroundColor: '#7da0b0'
        }
    },
  }));
  

const Statistics = (props) => {


    const [loading,setLoading] = useState(true);
    const [stats,setStats] = useState([]);
    const [sessions,setSessions] = useState([]);
    const [filterDate,setFilterDate] = useState({start:moment().subtract(1, 'month').format('Y-MM-DD'),end: moment().format('Y-MM-DD')});
    const [deleteConfirmTrans, setDeleteConfirmTrans] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const fetchStats = useCallback(async () => {
        let stats = await StatsService.getStats(filterDate);
        setStats(stats.data);
      }, [filterDate])
    
    const fetchSession = useCallback(async () => {
        let stats = await StatsService.getSessions(filterDate);
        if(stats.data instanceof Array) {
            stats.data.forEach(session => {
                const newTranscriptions = [session.spoken_language];
                if(session.spoken_language != session.written_language)
                    newTranscriptions.push(session.written_language);

                if(session.transcriptions && session.transcriptions instanceof Array && !session.transcriptions.length) {
                    session.transcriptions.forEach(transcription => {
                        if(!transcription.lang || transcription.lang.startsWith('corrected_') ||
                            newTranscriptions.includes(transcription.lang)) return;
                        newTranscriptions.push(transcription.lang);
                    });
                }
                session.transcriptions = newTranscriptions;
            });
        }
        setSessions(setParentRow(stats.data));
    }, [filterDate])

      //useful for tree data
      const setParentRow = (data)=>{
        const groupBy = _.groupBy(data,'conversationId')

        for (const [key, value] of Object.entries(groupBy)) {
        
            if(value[0].conversationCounter){
                const parent={...value[0]}
                parent.idParent = Math.random().toString(36).substring(2, 12+2)
                delete( parent.conversationCounter )//avoid render #
                
                let nb_users=0
                let nb_part=0
                let nb_inv=0
                let nb_comp=0
                let duration=0;
             
                for (const s of value) {
                    s.parentId = parent.idParent
                    nb_users += s.participants.length
                    nb_part += s.events.filter(e => typeof e == 'object' && e.event == "USER_JOIN").length
                    nb_inv += s.events.filter(e => typeof e == 'object' && e.event == "TRANSCRIPTION_JOIN").length
                    nb_comp += s.events.filter(e => typeof e == 'object' && e.event == "TRANSCRIPTION_GUEST_JOIN").length
                    duration += s.duration;
                }
                
                parent.nb_users = nb_users
                parent.nb_part = nb_part
                parent.nb_inv = nb_inv
                parent.nb_comp = nb_comp
                parent.duration = duration
                parent.nb_conversation = value.length
                value.push(parent)
            }
         
        }
        console.log(groupBy)

        return _.flatMap(groupBy);
    }

    const translateType = (data) => {
        let type;

        if (!data.type) return 'Conversation';

        switch(data.type){
            case 'hygia': 
                type = 'Hygia';
                break;
            case 'hygia_phone': 
                type = 'Hygia-Phone';
                break;
            case 'file': 
                type = 'Fichier audio';
                break;
            case 'file-batch': 
                type = 'Fichier audio async';
                break;
            case 'file-ssml': 
                type = 'Fichier SSML';
                break;
            default:
                type = data.type;
        }

        if(data.properties && data.properties.TTSEnabled){
            type += ' (Audio)';
        }

        return type;
    }

    const downloadFile = (data) => {
        StatsService.downloadFile(data).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            if(response.headers['content-type'] === "application/octet-stream" || response.headers['content-type'] === "application/zip"){
                link.setAttribute('download', `${data.conversationId}.zip`);
            }
            else{
                link.setAttribute('download', `${data.conversationId}.txt`);
            }
            document.body.appendChild(link);
            link.click();
          })
          .catch((err)=>{
               alert(err.response.status == 401 ? 'Vous n\'avez pas la permission de télécharger ce fichier.' : 'Le fichier n\'existe pas.')
          });
    };

    const deleteFile = (data) => {
        setShowDeleteModal(false);
        StatsService.deleteFile(data).then((response) => {
            setSessions(value => {
                value.forEach(v => {
                    if(v._id == data._id) v.downloadable = false;
                });
                return [...value];
            });
        })
        .catch((err)=>{
            alert(err.response.status == 401 ? 'Vous n\'avez pas la permission de supprimer ce fichier.' : 'Le fichier n\'existe pas.')
        });
    };


    useEffect( () => {

        (async () => {
            try {
                setLoading(true);
                await fetchStats();
                await fetchSession();
                setLoading(false);
            } catch (error) {
                console.error(error);
            }
        })();
       
    },[filterDate]);

    const onFilterSubmit = (values,form) => {
     
        if( moment(values.start).isAfter(values.end) ){
            alert('La date de début doit être inférieure à la date de fin !');
            return false;
        };
        
        setFilterDate(values);
    }

    const onDownloadConso = () => {
        StatsService.downloadConso({ start: filterDate.start, end: filterDate.end }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([JSON.stringify(response.data)]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `all-conso.json`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err)=>{
               alert('Le fichier n\'existe pas.')
          });
    }
    
    const columns = [
        { field: 'conversationId', title: "ID", minWidth: 120,render: data=> { 
            return data.idParent ? data.conversationId + " (" + data.nb_conversation + ")"  : data.conversationCounter ? data.conversationId + ' #'+ data.conversationCounter  : data.conversationId
        } },
        { field: 'host', title: "Hôte", minWidth: 120, render: data => data.host ?  `${data.host.first_name} ${data.host.last_name}` : 'inconnu' },
        { field: 'type', title: 'Type', minWidth: 120, render: data => { 
            return data.hygia ? (data.hygia_mode == 'phone' ? 'Hygia-Phone' : 'Hygia') : translateType(data);
        } },
        { field: 'participants', title: "Nb utilisateurs", minWidth: 120, render: data => { 
            return  data.idParent ?  data.nb_users : (data.hygia && data.hygia_mode != 'phone') ? 2 : data.participants.length; 
        } },
        { field: 'total_participants', title: "Nb participants", minWidth: 120, render: data => { 
            return  data.idParent ? data.nb_part : data.events.filter(e => typeof e == 'object' && e.event == "USER_JOIN").length; 
        } },
        { field: 'guest_participants', title: "Nb invités", minWidth: 120, render: data => { 
            return data.idParent ? data.nb_inv : data.events.filter(e => typeof e == 'object' && e.event == "TRANSCRIPTION_JOIN").length; 
        } },
        { field: 'companion_participants', title: "Nb compagnons", minWidth: 120, render: data => { 
            return data.idParent ? data.nb_comp :  data.events.filter(e => typeof e == 'object' && e.event == "TRANSCRIPTION_GUEST_JOIN").length; 
        } },
        { field: 'transcriptions', title: "Langues", minWidth: 120, render: data => {
            return  data.idParent ? '/' : data.transcriptions && data.transcriptions.length ? data.transcriptions.map(i => ((i && i.includes('-')) ? i.split('-')[1] : i)).join(' | ') : 'N/A';
        }},
        { field: 'created_at', title: "Début", minWidth: 120, render: data => data.created_at ?  new Date(data.created_at).toLocaleString() : 'error' },
        { field: 'finished_at', title: "Fin", minWidth: 200, align: 'left', render: data => data.finished_at ?  new Date(data.finished_at).toLocaleString() : 'error' },
        { field: 'duration', title: "Durée réelle", minWidth: 100, align: 'right',render: data => data.duration  ? new Date(data.duration * 1000).toISOString().substr(11, 8) : 'error' }
    ];

    const parentChildData = (row, rows) => {
        return row.parentId ?  rows.find(r =>  r.idParent === row.parentId ) : undefined
    }

    const actions = [
        rowData => ({
            icon: CloudDownloadIcon,
            tooltip: rowData.downloadable ? 'Télécharger transcription' : undefined,
            onClick: (event, rowData) => downloadFile(rowData),
            disabled: !rowData.downloadable
        }),
        rowData => ({
            icon: DeleteOutlineIcon,
            tooltip: rowData.downloadable ? 'Supprimer transcription' : undefined,
            onClick: (event, rowData) => { setDeleteConfirmTrans(rowData); setShowDeleteModal(true); },
            disabled: !rowData.downloadable
        }),
    ]

    const classes = useStyles();

    return (
        <>
            <BackdropLoader open={loading} />
            <h1><Trans>Statistics</Trans></h1>

            {/* filters */}
            <Form
                onSubmit={onFilterSubmit}
                initialValues={filterDate}
                render={({ handleSubmit, form, submitting, pristine, values })=>(
                    <form onSubmit={handleSubmit} noValidate>
                    <Grid container direction="row" justify="flex-start" alignItems="center" style={ { width: '100%', display: 'flex', justifyContent: 'flex-start', flexWrap: 'nowrap' } }>    
                        {/* <Grid item xs={4}> */}
                            <Box p={1}>
                                <Field name="start">
                                    {props => 
                                    // <TextField variant="outlined" fullWidth {...props} {...props.input}/>
                                    <TextField
                                        {...props.input}
                                        id="start"
                                        name="start"
                                        label="Début"
                                        type="date"
                                        defaultValue={values.start}
                                        className={classes.textField}
                                        InputLabelProps={{
                                        shrink: true,
                                        }}
                                    />
                                    }
                                </Field>
                            </Box>
                        {/* </Grid> */}
                        {/* <Grid item xs={4}> */}
                            <Box p={1}>
                                <Field name="end">
                                    {props => 
                                    // <TextField variant="outlined" fullWidth {...props} {...props.input}/>
                                    <TextField
                                        {...props.input}
                                        id="end"
                                        name="end"
                                        label="Fin"
                                        type="date"
                                        defaultValue={values.start}
                                        className={classes.textField}
                                        InputLabelProps={{
                                        shrink: true,
                                        }}
                                    />
                                    }
                                </Field>
                            </Box>
                        {/* </Grid> */}
                        {/* <Grid item xs={4}> */}
                            <Button type="submit" className={`shadow-2 mb-4 ${classes.btn}`}>Filtrer</Button>
                        {/* </Grid> */}

                        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Button type="button" className={`shadow-2 mb-4 ${classes.btn}`} onClick={onDownloadConso}>Télécharger les consommations</Button>
                        </div>
                    </Grid>
                </form>
                )}
                >
            </Form>
            <Divider />

            {
                stats && !loading &&
                <Grid container spacing={3}>
                <Grid item xs={4}>
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>
                            Total comptes utilisateur
                            </Typography>
                            <Typography variant="h5" component="h2" >
                             {stats.total_accounts}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={4}>
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>
                            Total sessions
                            </Typography>
                            <Typography variant="h5" component="h2" >
                            {stats.total_sessions}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={4}>
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>
                            Temps total en conversation
                            </Typography>
                            <Typography variant="h5" component="h2" >
                            {formatSeconds(stats.total_time_seconds,['H','m','s'])}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={4}>
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>
                            Total participants
                            </Typography>
                            <Typography variant="h5" component="h2" >
                            {stats.total_participants}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={4}>
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>
                            Temps moyen par conversation
                            </Typography>
                            <Typography variant="h5" component="h2" >
                            {formatSeconds(stats.average_time_session,['H','m','s'])}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            }
            {
                sessions &&
                <Grid container spacing={5}>
                    <Grid item xs={12}>
                        <MaterialTable
                            columns={columns}
                            parentChildData={parentChildData}
                            data={sessions}
                            title={"Sessions"}
                            actions={actions}
                        />
                    </Grid>
                </Grid>
            }
            {
                <Modal
                    open={showDeleteModal}
                    onClose={() => setShowDeleteModal(false)}
                >
                    <h4 style={{width: '100%', textAlign: 'center', marginBottom: '0'}}>Etes-vous sur de supprimer la transcription #{deleteConfirmTrans ? deleteConfirmTrans.conversationId : ''} ?</h4>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button type="button" className={`shadow-2 mb-4 ${classes.btn}`} style={{marginRight: '8px'}} onClick={() => deleteFile(deleteConfirmTrans)}>Confirmer</Button>
                        <Button type="button" className={`shadow-2 mb-4 ${classes.btn}`} onClick={() => setShowDeleteModal(false)}>Annuler</Button>
                    </div>
                </Modal>
            }
        </>
    );
}

export default Statistics;